module.exports = __webpack_public_path__ + "swipper-2.png?6b4f119fdadf4fb555af540702f7ddd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swipper-2.png
// module id = 188
// module chunks = 0